import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
export function SummaryTable() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-180" data-mp="o606ydatvopg">
      <div className="mx-auto max-w-4xl px-4" data-id="element-181" data-mp="j76soinpvto8">
        <SectionHeading id="summary-title" data-id="element-182" data-mp="j8880zbrn2br">Everything <span className="text-yellow-400" data-id="element-183" data-mp="j5c7d38j9zjm">Included:</span></SectionHeading>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-slate-600/60 bg-blue-950 sm:grid-cols-2" data-id="element-184" data-mp="1gu5sh29phhqc">
          {summaryRows.map(feature => <li key={feature} className="flex items-start gap-3 border-b border-slate-600/30 p-4 sm:odd:border-r" data-id="element-185" data-mp="16w866kbepv0d">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-yellow-400" data-id="element-186" data-mp="12vxnq86fhc4m">
                <CheckIcon className="h-3.5 w-3.5 text-slate-950" aria-hidden="true" data-id="element-187" data-mp="3rnrt3b2a9efq" />
              </span>
              <b className="text-sm text-stone-50" data-id="element-188" data-mp="3njtvj4slwbos">{feature}</b>
            </li>)}
        </ul>
      </div>
    </section>;
}